import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { fetchAllRulesRequest, setActiveListener } from '../../../../../../../actions/subscriber';
import { callTokenApi } from '../../../../../../../apiCaller';
import { API_CLIENT_RULE, RULE_GROUP } from '../../../../../../../constants';
import { toastError } from '../../../../../../../utils';
import CenterSpinner from '../../../../../../general/Loadings/CenterSpinner';

import { RuleContext } from './CreateFormCrawlRule';
import EditStepSelectListenerForm from './Step1';
import EditStepRuleName from './lookup/EditStep2';
import EditStepSelectConditionFields from './lookup/EditStep3';

const EditNewFromCrawlRuleSteps = () => {
     return (
          <>
               <EditStepSelectListenerForm actionType="edit" />
               <EditStepRuleName />
               <EditStepSelectConditionFields actionType="edit" />
          </>
     );
};

const EditFormCrawlRule = ({ id }) => {
     const dispatch = useDispatch();
     const redirectRules = useSelector((state) => state.subscriber.redirectRules);
     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const accountListeners = useSelector((state) => state.subscriber.accountListeners);
     const editingRuleReload = useSelector((state) => state.subscriber.editingRuleReload);
     const formCrawlRules = useSelector((state) => state.subscriber.formCrawlRules);

     const [rule, setRule] = useState(null);
     const [activeStep, setActiveStep] = useState(1);
     const [fetchRuleLoading, setFetchRuleLoading] = useState(true);

     const fetchAllFormCrawlRules = () => {
          if (!formCrawlRules) {
               dispatch(fetchAllRulesRequest(activeAccount.id, RULE_GROUP.FORM_CRAWL_RULE));
          }
     };
     useEffect(fetchAllFormCrawlRules, []); // eslint-disable-line react-hooks/exhaustive-deps

     const fetchRule = () => {
          callTokenApi(`${API_CLIENT_RULE}${id}`, 'GET')
               .then((response) => {
                    if (response.status !== 200) {
                         toastError(response);
                         return;
                    }

                    const { rule } = response.data;

                    if (rule.accountId !== activeAccount.id) {
                         window.location.href = '/';
                    }
                    setRule(rule);

                    const currentListener = accountListeners?.find((listener) => listener.id === rule.listenerId);
                    if (currentListener) {
                         dispatch(setActiveListener(currentListener));
                    }
               })
               .finally(() => {
                    setFetchRuleLoading(false);
               });
     };
     useEffect(() => {
          if (rule && !editingRuleReload) return;

          fetchRule();
     }, [rule, editingRuleReload, accountListeners]); // eslint-disable-line react-hooks/exhaustive-deps

     if (fetchRuleLoading || !rule) {
          return <CenterSpinner />;
     }

     return (
          <div className="rule-detail">
               <div className="cvr-create-new custom-rule">
                    {redirectRules.status && <Redirect to={redirectRules.to} />}
                    <h1 className="d-flex">Edit Form Crawl Rule: {rule.name}</h1>
                    <p>Use the steps below to configure your rule.</p>
                    <RuleContext.Provider value={{ rule, activeStep, setRule, setActiveStep }}>
                         <EditNewFromCrawlRuleSteps />
                    </RuleContext.Provider>
               </div>
          </div>
     );
};

export default EditFormCrawlRule;
